<template>
  <div class="home member-container">
    <MemberAside/>
    <div class="member-main">
      <MemberHeader/>
      <div class="member-content">
         <router-view/>
      </div>
      <p class="footer-text">© {{new Date().getFullYear()}} Zeal Capital Market (UK) Limited.</p>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import MemberAside from '@/components/layout/MemberAside'
import MemberHeader from '@/components/layout/MemberHeader'
export default {
  name: 'home',
  created() {
    this.$store.dispatch('initInfo')
    this.$store.dispatch('initUserInfo')
  },
  components: {
    MemberAside,
    MemberHeader
  }
}
</script>

<style lang="scss">
.member-main {
  margin-left: 224px;
  min-height: 1000px;
  .member-content {
    margin: 40px 36px 40px 36px;
  }
  .footer-text {
    font-family: 'AdobeHeitiStd-Regular';
    text-align: center;
    font-size: 14px;
    line-height: 50px;
    color: #999999;
  }
}
</style>
